<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VkkYQ4/Images/cover.jpg?1718756691761" alt="This image is the cover for the book Normal Family"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Normal Family
      </h1>
      <p class="bookDescription body article font2">
        <p>This hilarious novel is set over four consecutive holidays in the chaotic year 1968 with an eccentric family in decline. Normal Family manages to be good fun and deal with deeper, more serious issues almost simultaneously. The memorable characters include a senile grandfather, once a famous novelist but now an alcoholic; a genius older brother who torments the young narrator; and a brilliant mother looking to break free.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Don Trowden
      </h2>
      
      <p class="authorDescription body article"><p>Don Trowden is a longtime student of fiction and general man about town (e.g., Nowheresville, USA) who has an active imagination and has published non-fiction under another name. Normal Family is the first volume in the tragi-comic Pendergast family saga.</p></p>
      
      
         <a class="authorURL body link" href="http://www.dontrowden.com/" target="_blank">
      
              About Author
         </a>
         <br/>
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Publerati, LLC
     </h2>
        
        
     <a class="publisherURL body link" href="http://www.publerati.com/" target="_blank">
  
          About Publisher
     </a>
     <br/>
  
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?713f21cc